module.exports = __webpack_public_path__ + "img/20210828_213653.8b620fd8.jpg";